export default __webpack_public_path__ + "static/media/Destination.c1adc748.svg";